import space from '../../../images/product-page/comparison/space.svg';
import size from '../../../images/product-page/comparison/size.svg';
import weight from '../../../images/product-page/comparison/weight.svg';
import electricity from '../../../images/product-page/comparison/electricity.svg';
import noise from '../../../images/product-page/comparison/noise.svg';
import tank from '../../../images/product-page/comparison/tank.svg';
import refill from '../../../images/product-page/comparison/cycle.svg';
import oneButton from '../../../images/product-page/comparison/one-button.svg';
import other from '../../../images/product-page/comparison/other.svg';

export default [
  {
    image: other,
    title: 'model_comparison.other',
    values: [
      'model_comparison.other.evachill',
      'model_comparison.other.evalight',
      'model_comparison.other.evasmart',
    ],
  },
  {
    image: oneButton,
    title: 'model_comparison.control',
    values: [
      'model_comparison.control.evachill',
      'model_comparison.control.evalight',
      'model_comparison.control.evasmart',
    ],
  },
  {
    image: size,
    title: 'model_comparison.size',
    values: [
      'model_comparison.size.evachill',
      'model_comparison.size.evalight',
      'model_comparison.size.evasmart',
    ],
  },
  {
    image: weight,
    title: 'model_comparison.weight',
    values: [
      'model_comparison.weight.evachill',
      'model_comparison.weight.evalight',
      'model_comparison.weight.evasmart',
    ],
  },
  {
    image: tank,
    title: 'model_comparison.tank',
    values: [
      'model_comparison.tank.evachill',
      'model_comparison.tank.evalight',
      'model_comparison.tank.evasmart',
    ],
  },
  {
    image: refill,
    title: 'model_comparison.refill',
    values: [
      'model_comparison.refill.evachill',
      'model_comparison.refill.evalight',
      'model_comparison.refill.evasmart',
    ],
  },
  {
    image: space,
    title: 'model_comparison.space',
    values: [
      'model_comparison.space.evachill',
      'model_comparison.space.evalight',
      'model_comparison.space.evasmart',
    ],
  },
  {
    image: noise,
    title: 'model_comparison.noise',
    values: [
      'model_comparison.noise.evachill',
      'model_comparison.noise.evalight',
      'model_comparison.noise.evasmart',
    ],
  },
  {
    image: electricity,
    title: 'model_comparison.electricity',
    values: [
      'model_comparison.consumption.evachill',
      'model_comparison.consumption.evalight',
      'model_comparison.consumption.evasmart',
    ],
  },
];
